module.exports = __webpack_public_path__ + "img/knowledgeBase.7b8573ca.png";